module.exports = __webpack_public_path__ + "static/media/BlackButtonMask.4fed72ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Masks/BlackButtonMask.png
// module id = 37
// module chunks = 0